<template>
  <div class="page">
    <div class="asidebox">
      <div class="aside_hongbao">
        <div style="color:#ccc;padding-bottom:10px;">红包预览</div>
        <img src="/img/红包.png" />
      </div>

      <div class="asidebox_child">
        <div style="color:#999999;">红包样式</div>
        <div v-for="(item,index) in types" :key="index" class="asideboxs">
          <span :class="typei == index?'btns':'btn'" @click="selecttype(index)">{{item}}</span>
        </div>
      </div>

      <div class="asidebox_child" style="margin:10px 0;">
        <div style="color:#999999;">选择项目</div>
        <div class="asideboxs">
          <el-select v-model="value" placeholder="请选择" @change="selectproject">
            <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>

      <div class="asidebox_child">
        <div style="color:#999999;">接收对象</div>
        <div class="asideboxs">
          <div class="btns" style="width:100px;height:30px;" @click="payee">导入接收人</div>
        </div>
      </div>

      <div class="asidebox_child" v-show="personlist.length != 0" style="margin-top:10px;">
        <div style="color:#999999;">&emsp;&emsp;&emsp;&emsp;</div>
        <div class="asideboxs">
          <div class="asideboxs_child">
            <div v-for="(item,index) in personlist" :key="index" class="asideboxs_childs">
              <img :src="item.user_avatar" style="width:15px;height:15px;border-radius:50%;margin-right:3px;" />
              <input type="checkbox" v-model="item.checked" @click="inputmoney(index)" />
              <span>{{item.alias_name}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="asidebox_child" style="margin-top:10px;">
        <div style="color:#999999;">单个红包金额</div>
        <div class="aside_box">
          <input type="number" @blur="blur" placeholder="  请输入金额(数字)" v-model="money" />
          <span style="color:#ccc;padding-left:5px;">元</span>
        </div>
      </div>

      <div class="asidebox_child" style="margin:10px 0;">
        <div style="color:#999999;">付款明细</div>
        <div class="aside_box">
          付款总金额
          <span style="color:#557bdf;">
            ￥
            <span style="font-size:16px;">{{totalmoney}}</span>
          </span>元
        </div>
      </div>

      <div class="asidebox_child" style="margin:10px 0;">
        <div style="color:#999999;">付款说明</div>
        <div class="aside_box">
          <textarea cols="30" rows="4" v-model="instructions"></textarea>
        </div>
      </div>

      <div class="asidebox_child">
        <div style="color:#999999;">输入密码</div>
        <div class="asideboxs">
          <input type="password" v-model="password" />
        </div>
      </div>

      <div class="asidebox_child" style="margin-top:10px;padding-bottom:10px;">
        <div style="color:#999999;">&emsp;&emsp;&emsp;&emsp;</div>
        <div class="asideboxss">
          <div class="btns" @click="confirmpayment">确认付款</div>
        </div>
      </div>

      <el-dialog title="导入人员" :visible.sync="centerDialogVisible" width="40%" center>
        <div>
          <div style="margin-top: 15px;">
            <el-input placeholder="请输入内容" v-model="searchvalue">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
              <template slot="append">搜索</template>
            </el-input>
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:10px;">
            <el-tab-pane label="通讯录" name="first">
              <div style="overflow-y:scroll;overflow-x:hidden;height:200px;margin-bottom:30px;">
                <div v-for="(item,index) in friendlist" :key="index">
                  <div class="liststy">
                    <div class="liststy_top">
                      <img :src="item.user_avatar" style="width:30px;height:30px;border-radius:5px;" />
                      <div style="padding-left:7px;">
                        <p>{{item.friend_remarks}}</p>
                        <!-- <p>{{item.code}}</p> -->
                      </div>
                    </div>
                    <div class="liststy_bottom" @click="imperson(item.friend_user_app_id,item.friend_remarks)">导入人员</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="好友" name="second">
              <div style="overflow-y:scroll;overflow-x:hidden;height:200px;margin-bottom:30px;">
                <div v-for="(item,index) in friendlist" :key="index">
                  <div class="liststy">
                    <div class="liststy_top">
                      <img :src="item.user_avatar" style="width:30px;height:30px;border-radius:5px;" />
                      <div style="padding-left:7px;">
                        <p>{{item.friend_remarks}}</p>
                        <!-- <p>{{item.code}}</p> -->
                      </div>
                    </div>
                    <div class="liststy_bottom" @click="imperson(item.friend_user_app_id,item.friend_remarks)">导入人员</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="我推广的" name="third">
              <div style="overflow-y:scroll;overflow-x:hidden;height:200px;margin-bottom:30px;">
                <div v-for="(item,index) in promotelist" :key="index">
                  <div class="liststy">
                    <div class="liststy_top">
                      <img :src="item.user_avatar" style="width:30px;height:30px;border-radius:5px;" />
                      <div style="padding-left:7px;">
                        <p>{{item.alias_name}}</p>
                        <p>{{item.jz_number}}</p>
                      </div>
                    </div>
                    <div class="liststy_bottom" @click="imperson(item.user_app_id,item.alias_name)">导入人员</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="我的关注" name="fourth">
              <div style="overflow-y:scroll;overflow-x:hidden;height:200px;margin-bottom:30px;">
                <div v-for="(item,index) in attentionlist" :key="index">
                  <div class="liststy">
                    <div class="liststy_top">
                      <img :src="item.follow_user_avatar" style="width:30px;height:30px;border-radius:5px;" />
                      <div style="padding-left:7px;">
                        <p>{{item.follow_alias_name}}</p>
                        <!-- <p>{{item.code}}</p> -->
                      </div>
                    </div>
                    <div class="liststy_bottom" @click="imperson(item.follow_user_app_id,item.follow_alias_name)">导入人员</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="关注我的" name="fourths">
              <div style="overflow-y:scroll;overflow-x:hidden;height:200px;margin-bottom:30px;">
                <div v-for="(item,index) in beanlist" :key="index">
                  <div class="liststy">
                    <div class="liststy_top">
                      <img :src="item.fans_user_avatar" style="width:30px;height:30px;border-radius:5px;" />
                      <div style="padding-left:7px;">
                        <p>{{item.fans_alias_name}}</p>
                        <!-- <p>{{item.code}}</p> -->
                      </div>
                    </div>
                    <div class="liststy_bottom" @click="imperson(item.user_app_id,item.fans_alias_name)">导入人员</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog>

      <el-dialog title="付款确认" :visible.sync="paymentflag" width="30%" center>
        <div>
          <div>
            本次共付款
            <span>{{totalmoney}}</span>
            元，共有{{num}}位收款人
          </div>
          <div class="queren">
            <div v-for="(item,index) in personlist" :key="index" class="queren_child">
              <img v-show="item.checked" :src="item.user_avatar" />
              <span v-show="item.checked">{{item.alias_name}}</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="paymentflag = false">取 消</el-button>
          <el-button type="primary" @click="paymentconfirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  projectlist,
  externalgetUserList,
  fanspeoples,
  followpeoples,
  extensionpeoples,
  userpeoples,
  redpacktoadd
} from "@/api/login/login";
export default {
  data () {
    return {
      paymentflag: false,
      money: "",
      password: "",
      instructions: "",
      totalmoney: 0,
      activeName: "first",
      searchvalue: "",
      centerDialogVisible: false,
      options: [],
      value: "",
      typei: 0,
      types: ["普通红包", "贺卡红包"],
      projectid: "",
      personlist: [],
      friendlist: [],
      attentionlist: [],
      beanlist: [],
      promotelist: [],
      num: 0
    };
  },
  created () {
    this.getproject();
  },
  mounted () { },
  methods: {
    inputmoney (index) {
      this.num = 0;
      let _this = this;
      let timer = setTimeout(function () {
        _this.personlist.forEach(item => {
          if (item.checked) {
            _this.num++;
          }
        });
        if (_this.num == 0) {
          _this.totalmoney = 0;
        }
        if (_this.num != 0 && Number(_this.money) > 0) {
          _this.summoney();
        }
      }, 500); // 定时时间
    },
    //失焦事件
    blur () {
      if (this.money == "") {
        this.totalmoney = 0;
        return;
      }
      if (this.money < 0) {
        this.totalmoney = 0;
        return;
      }
      this.num = 0;
      this.personlist.forEach(item => {
        if (item.checked) {
          this.num++;
        }
      });
      if (this.num != 0 && Number(this.money) > 0) {
        this.summoney();
      }
    },
    //计算总金额
    summoney () {
      this.num = 0;
      this.personlist.forEach(item => {
        if (item.checked) {
          this.num++;
        }
      });
      this.totalmoney = (this.num * parseFloat(this.money)).toFixed(2);
    },
    //确认付款
    paymentconfirm () {
      let list = [];
      let person = {};
      this.personlist.forEach(item => {
        if (item.checked) {
          person = {
            user_app_id: item.user_app_id,
            user_name: item.alias_name,
            project_id: this.projectid
          };
          list.push(person);
        }
      });
      let data = {
        type: 1,
        project_id: this.projectid,
        money: this.money,
        y_money: this.totalmoney,
        password: this.password,
        data: list,
        content: this.instructions
      };
      redpacktoadd(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '发送成功'
          })
          this.projectid = ''
          this.personlist = []
          this.money = ''
          this.password = ''
          this.options = []
          this.totalmoney = 0
          this.paymentflag = false;
          this.value = '请选择'
          this.getproject()
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    //付款
    confirmpayment () {
      const reg = /^\d+(\.\d{0,2})?$/;
      if (this.projectid == "") {
        this.$message({
          type: "warning",
          message: "请先选择项目"
        });
        return;
      }
      if (this.money == "") {
        this.$message({
          type: "warning",
          message: "请设置红包金额"
        });
        return;
      }
      if (this.num == 0) {
        this.$message({
          type: "warning",
          message: "请选择收款人员"
        });
        return;
      }

      if (reg.test(this.money) == false || this.money <= 0) {
        this.$message({
          type: "warning",
          message: "红包金额不能为负"
        });
        return;
      }

      if (this.password == "") {
        this.$message({
          type: "warning",
          message: "请输入密码"
        });
        return;
      }

      this.paymentflag = true;
    },
    //获取项目列表
    getproject () {
      let datas = {
        status: 1
      };
      projectlist(datas).then(res => {
        let data = {};
        res.data.forEach(item => {
          data = {
            value: item.project_id,
            label: item.name
          };
          this.options.push(data);
        });
      });
    },
    //导入人员
    imperson (id, name) {
      let flag = false;
      flag = this.personlist.every(item => {
        return item.user_app_id != id;
      });
      if (flag) {
        let data = {
          alias_name: name,
          user_app_id: id,
          checked: true,
          project_id: this.projectid
        };
        this.personlist.push(data);
      } else {
        this.$message({
          type: "warning",
          message: "该人员已存在无需导入"
        });
      }
    },
    handleClick (tab, event) {
      console.log(tab, event);
    },
    //获取粉丝列表
    getfanslist () {
      fanspeoples().then(res => {
        this.beanlist = res.data;
      });
    },
    //获取我的关注
    getfollowlist () {
      followpeoples().then(res => {
        this.attentionlist = res.data;
      });
    },
    //获取我的推广
    extensionlist () {
      extensionpeoples().then(res => {
        this.promotelist = res.data;
      });
    },
    //获取我的好友
    userpeoples () {
      userpeoples().then(res => {
        this.friendlist = res.data;
      });
    },
    //导入接收人
    payee () {
      if (this.projectid == "") {
        this.$message({
          type: "warning",
          message: "请先选择项目"
        });
        return;
      }
      this.userpeoples();
      this.extensionlist();
      this.getfollowlist();
      this.getfanslist();
      this.centerDialogVisible = true;
    },
    //选择项目
    selectproject (e) {
      this.projectid = e;
      let data = {
        project_id: this.projectid
      };
      externalgetUserList(data).then(res => {
        this.personlist = res.data;
      });
    },
    //选择红包样式
    selecttype (i) {
      this.typei = i;
    }
  },
  components: {}
};
</script>

<style lang='scss' scoped>
.page {
  .queren {
    display: flex;
    flex-wrap: wrap;
    .queren_child {
      display: flex;
      align-items: center;
      width: 50%;
      margin: 10px 0;
      img {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        margin-right: 3px;
      }
    }
  }
  .liststy {
    margin: 7px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    .liststy_top {
      display: flex;
      align-items: center;
    }
    .liststy_bottom {
      width: 85px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #4c71db;
      border: 1px solid #4c71db;
      border-radius: 5px;
      margin-right: 5px;
    }
  }
  height: auto !important;
  .asidebox {
    .aside_hongbao {
      position: absolute;
      right: 100px;
      top: 20px;
      img {
        width: 250px;
        height: 350px;
      }
    }
    position: relative;
    padding-top: 40px;
    padding-left: 20px;
    .asidebox_child {
      display: flex;
      align-items: center;
      .aside_box {
        margin-left: 10px;
        display: flex;
        align-items: center;
      }
      .asideboxs {
        display: flex;
        flex-direction: column;
        margin-left: 20px;
        .asideboxs_child {
          width: 500px;
          display: flex;
          flex-wrap: wrap;
          .asideboxs_childs {
            display: flex;
            align-items: center;
            width: 33%;
          }
        }
      }
      //   .asideboxss {
      //     display: flex;
      //     flex-direction: column;
      //     margin-left: 20px;
      //     .asideboxss_child {
      //       .asideboxss_childs {
      //         display: flex;
      //         height: 50px;
      //         background-color: #eeeeee;
      //         .stys {
      //           display: flex;
      //           justify-content: flex-start;
      //           align-items: center;
      //         }
      //       }
      //       width: 845px;
      //       height: 264px;
      //       background: #ffffff;
      //       box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
      //       opacity: 1;
      //       border-radius: 4px;
      //     }
      //   }
      .btn {
        width: 120px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #eeeeee;
        border: 1px solid #eeeeee;
        border-radius: 8px;
      }
      .btns {
        width: 120px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        background-color: #4d71d9;
        border-radius: 8px;
      }
    }
  }
}
</style>
